<template>
  <div class="footer">
    <div class="footer_nav">
      <div class="footer_nav_menu" v-html="this.$store.state.bannerNavContainer"></div>
      <div class="footer_nav_contact">
        <div class="contact_content">
          <span>联系我们</span>
          <span>联系方式：<span v-html="$store.state.serverImages.contactText1"></span></span>
          <span v-html="$store.state.serverImages.contactText2"></span>
          <div class="leave_word" @click="changes()">
            我要留言
          </div>
        </div>

        <img   v-if="this.$store.state.serverImages.wxImages"  class="code_img" :src="this.$store.state.serverImages.wxImages" @click="imagesShowHander" alt="" />

        <div v-show="imagesShow" class="imagesShow" @mousewheel="showMouseWheel" @click="imagesShowHander">
          <div class="imagesShow_container">
            <!-- <img
              src="../../assets/images/关闭.png"
              title="关闭"
              alt=""
              class="imagesShow_close"
              @click="imagesShowHander"
            /> -->
            <img :src="this.$store.state.serverImages.wxImages" class="imagesShow_image" alt="" @mousewheel="showMouseWheel" />
          </div>
        </div>

        <!-- <img
          :src="this.$store.state.serverImages.wxImages[0]"
        /> -->
      </div>
    </div>
    <div class="footer_info">
      <span v-html="$store.state.serverImages.copyright"></span>
      <span v-html="$store.state.serverImages.support"></span>
    </div>

    <el-dialog title="游客留言" :visible.sync="leaveWordVisible" width="580px">
      <el-form :model="leaveWordForm" :rules="leaveWordRules" ref="leaveWordForm" label-width="100px">
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="leaveWordForm.userName" onkeyup="this.value=this.value.replace(/[^\w\u4E00-\u9FA5]/g,'')" maxlength="8"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="telephone">
          <el-input v-model="leaveWordForm.telephone" maxlength="11" show-word-limit onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="leaveWordForm.title"></el-input>
        </el-form-item>
        <el-form-item label="留言" prop="content">
          <el-input v-model="leaveWordForm.content" type="textarea" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="leaveWordSubmit('leaveWordForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data () {
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };

    return {
      bannerNavContainer: "",
      imagesShow: false,
      leaveWordVisible: false,
      leaveWordForm: {
        userName: "",
        // sex: "",
        telephone: "",
        // email: "",
        title: "",
        content: "",
        soId: this.$store.state.Soid
      },
      leaveWordRules: {
        // userName: [
        //   {
        //     required: true,
        //     message: "请输入姓名",
        //     trigger: "blur"
        //   }
        // ],
        // sex: [{ required: true, message: "请输入姓名", trigger: "change" }],
        // telephone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        // email: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        title: [{ required: true, message: "请输入留言标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入留言信息", trigger: "blur" }
        ]
      }
    };
  },
  created () {
     
   },
  methods: {
    // bannerNavClick(currentRole, key) {
    //   this.$router.push({ path: currentRole, query: { value: key } });
    // },
    // 显示与隐藏大图
    //留言弹窗
    changes () {
      this.leaveWordVisible = true;
      this.leaveWordForm.userName = '';
      this.leaveWordForm.telephone = '';
      this.leaveWordForm.title = '';
      this.leaveWordForm.content = '';
    },
    imagesShowHander () {
      this.scale = 1;
      $(".imagesShow_image").css({
        "margin-left": "0",
        "margin-top": "0",
        transform: "translate(-50%, -50%) scale(1)"
      });
      this.imagesShow = !this.imagesShow;
    },
    showMouseWheel (e) {
      let img = $(".imagesShow_image");
      //阻止滚动条滚动
      function scrollFunc (e) {
        e = e || window.event;
        if (e && e.preventDefault) {
          e.preventDefault();
          e.stopPropagation();
        } else {
          e.returnvalue = false;
          return false;
        }
      }
      scrollFunc();
      if (e.wheelDelta > 0) {
        this.scale = (this.scale + 0.1).toFixed(1) - 0;
      } else {
        if (this.scale > 0.1) {
          this.scale = (this.scale - 0.1).toFixed(1) - 0;
        }
      }
      img.css(
        "transform",
        "translate(-50%, -50%) scale(" + this.scale.toFixed(1) + ")"
      );
    },
    leaveWordSubmit (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.leaveWordVisible = false;

          this.axios
            .get(this.$store.state.Url10 + "touristMessage/addTouristMessage", {
              params: this.leaveWordForm
            })
            .then(data => {
              this.$message({
                showClose: true,
                duration: 1000,
                message: '留言成功！',
                type: "success"
              });
            })
            .catch(err => {
              this.$message({
                showClose: true,
                duration: 1000,
                message: err,
                type: "warning"
              });
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  activated () {
    $(".code_img").click(function () {
      $(".el-image__preview").click(function () {
        $(".el-image-viewer__wrapper").show();
      });
      $(".el-image-viewer__canvas").click(function () {
        $(".el-image-viewer__wrapper").hide();
      });
    });
  }
};
</script>

<style lang="scss">
.footer {
  width: 100%;
  padding: 50px 0;
  background-color: #333333;
  color: #999999;
  font-size: 13px;
  overflow: hidden;

  .footer_nav {
    width: 100%;
    height: 200px;
    padding-left: 5%;
    & > div {
      width: 50%;
      float: left;
    }

    .footer_nav_menu {
      display: flex;
      justify-content: flex-end;
      right: 50px;
      position: relative;

      & > div {
        width: 100px;
        float: left;

        span {
          display: block;
          cursor: pointer;
          padding: 5px;

          &:nth-child(2) {
            margin-top: 20px;
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .footer_nav_contact {
      .contact_content {
        width: auto;
        float: left;

        p {
          padding: 0;
          margin: 0;
          display: inline;
        }

        & > span {
          padding: 5px;
          display: block;

          &:nth-child(2) {
            margin-top: 20px;
          }
        }

        .leave_word {
          margin: 20px 5px 5px 5px;
          width: 120px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          border: 1px solid #ffffff;
          cursor: pointer;
          color: white;

          &:hover {
            border: 0px solid rgba(255, 255, 255, 0);
            width: 122px;
            height: 34px;
            line-height: 34px;
            background: linear-gradient(to left, #08961e, #66bb6a);
          }
        }
      }

      .code_img {
        width: 140px;
        height: 140px;
        float: left;
        margin-left: 50px;
        padding: 5px;
      }
    }
  }

  .footer_info {
    width: 100%;
    text-align: center;

    p {
      padding: 0;
      margin: 0;
      display: inline;
    }

    span {
      font-size: 12px;
      padding: 0 20px;
    }
  }
}

.imagesShow {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 666;
}
.imagesShow_container {
  position: relative;
  height: 100%;
}
.imagesShow_close {
  position: absolute;
  top: 0;
  right: -2px;
  z-index: 23;
  cursor: pointer;
}
.imagesShow_image {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1);
  z-index: 33;
  cursor: pointer;
}

@media only screen and (max-width: 1580px) {
  .footer {
    .footer_nav {
      .footer_nav_menu {
        & > div {
          width: 70px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue